"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatus = exports.SurveyType = void 0;
var SurveyType;
(function (SurveyType) {
    SurveyType["CUSTOMER_EXPERIENCE"] = "customer_experience";
    SurveyType["COMMUNITY_SURVEY"] = "community_survey";
    SurveyType["COMMUNITY_ASKS"] = "community_asks";
    SurveyType["BLOCKWISE"] = "blockwise";
    SurveyType["BLOCKWISE_LEGACY"] = "blockwise_legacy";
    SurveyType["PULSE"] = "pulse";
    SurveyType["NETWORK_SPEED"] = "network_speed";
    SurveyType["BENCHMARK"] = "benchmark";
})(SurveyType = exports.SurveyType || (exports.SurveyType = {}));
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["DRAFT"] = "draft";
    SurveyStatus["PUBLISHED"] = "published";
    SurveyStatus["CLOSED"] = "closed";
    SurveyStatus["CANCELED"] = "canceled";
})(SurveyStatus = exports.SurveyStatus || (exports.SurveyStatus = {}));
//# sourceMappingURL=survey.js.map